import { render, staticRenderFns } from "./SignatureComponent.vue?vue&type=template&id=61ae3200&scoped=true"
import script from "./SignatureComponent.vue?vue&type=script&lang=js"
export * from "./SignatureComponent.vue?vue&type=script&lang=js"
import style0 from "./SignatureComponent.vue?vue&type=style&index=0&id=61ae3200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ae3200",
  null
  
)

export default component.exports